import { z } from "zod";
const environmentConfigSchema = z.object({
    descopeProjectId: z.string().min(1),
    authBaseUrl: z.url(),
    identityPoolId: z.string().optional(),
    rumAppMonitorId: z.string().optional()
});
// The origin that served this code, not the page's: the top-bar widget runs embedded on other
// Tickaroo pages but is served from the apps host, which is where its environment's API lives.
// Deliberately not `new URL(path, import.meta.url)` — Vite rewrites that form as an asset import.
export function environmentConfigUrl(moduleUrl) {
    return `${new URL(moduleUrl).origin}/management/api/config`;
}
export async function loadEnvironmentConfig(url, fetchFn = fetch) {
    const response = await fetchFn(url);
    if (!response.ok) {
        throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
    }
    return environmentConfigSchema.parse(await response.json());
}
//# sourceMappingURL=environmentConfig.js.map